module.exports = __webpack_public_path__ + "static/media/welcome-slider-3-es-md.139231ba.png";